import { create } from "zustand";

interface ModalState {
  component: React.ReactNode;
}

const useModalStore = create<ModalState>(() => ({
  component: null
}));

export function closeModal() {
  useModalStore.setState(() => ({ component: null }));
}

export function openModal(component: React.ReactNode) {
  useModalStore.setState(() => ({ component: component }));
}

export default useModalStore;
